import React, { useState, useEffect } from "react";
import CommonModal from "../../../components/commonModal/CommonModal";
import useSubmitting from "../../../hooks/useSubmitting";
import InputText from "../../../components/inputs/InputText";
import companyApiService from "../../services/companyApiService";
import { toast } from "react-toastify";

interface AddShopProps {
  setopen: (value: boolean) => void;
  open: boolean;
  shop?: any;
  setShop?: any;
  onSuccess?: () => void;
}

const AddShop: React.FC<AddShopProps> = ({
  setopen,
  open,
  shop,
  setShop,
  onSuccess,
}) => {
  const state = {
    firstName: "",
    lastName: "",
    phoneNumber: "",
    address: "",
    email: "",
    password: "",
    confirmPassword: "",
    companyName: "",
    logo: "default-logo",
  };

  const [formData, setformData] = useState(state);

  useEffect(() => {
    if (shop) {
      setformData({
        firstName: shop.firstName || "",
        lastName: shop.lastName || "",
        phoneNumber: shop.phoneNumber || "",
        address: shop.address || "",
        email: shop.email || "",
        password: "",
        confirmPassword: "",
        companyName: shop.companyName || "",
        logo: shop.logo || "",
      });
    }
  }, [shop, open]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    // Validation
    if (formData.password !== formData.confirmPassword) {
      toast.error("Passwords do not match!");
      return;
    }

    if (formData.password.length < 6) {
      toast.error("Password must be at least 6 characters long!");
      return;
    }

    try {
      // Create portal admin with company and super admin
      const response =
        await companyApiService.createPortalAdminWithCompany(formData);
      toast.success(
        "Portal Admin, Company, and Super Admin created successfully!",
      );

      setopen(false);
      setformData(state);
      if (onSuccess) {
        onSuccess();
      }
    } catch (err: any) {
      console.error("Failed to create portal admin with company:", err);
      const errorMessage =
        err?.response?.data?.message ||
        "Failed to create portal admin. Please try again.";
      toast.error(errorMessage);
    }
  };

  const [submitting, wrap] = useSubmitting();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setformData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const onCancel = () => {
    setShop?.();
    setformData(state);
  };

  return (
    <CommonModal
      onSubmit={wrap(handleSubmit)}
      setopen={setopen}
      open={open}
      title="Create Portal Admin"
      submit="submit"
      onCancel={onCancel}
      submitting={submitting}
      submittingText="Creating..."
    >
      <InputText
        label="First Name"
        type="text"
        name="firstName"
        value={formData.firstName}
        onChange={handleChange}
        required
      />
      <InputText
        label="Last Name"
        type="text"
        name="lastName"
        value={formData.lastName}
        onChange={handleChange}
        required
      />
      <InputText
        label="Phone Number"
        type="text"
        name="phoneNumber"
        value={formData.phoneNumber}
        onChange={handleChange}
        required
      />
      <InputText
        label="Email"
        type="email"
        name="email"
        value={formData.email}
        onChange={handleChange}
        required
      />
      <InputText
        label="Address"
        type="text"
        name="address"
        value={formData.address}
        onChange={handleChange}
        required
      />
      <InputText
        label="Company Name"
        type="text"
        name="companyName"
        value={formData.companyName}
        onChange={handleChange}
        required
      />
      <InputText
        label="Password"
        type="password"
        name="password"
        value={formData.password}
        onChange={handleChange}
        required
      />
      <InputText
        label="Confirm Password"
        type="password"
        name="confirmPassword"
        value={formData.confirmPassword}
        onChange={handleChange}
        required
      />
    </CommonModal>
  );
};

export default AddShop;
